export const orderSuppliers = (suppliers, selectedSuppliers, field = 'code') =>{
    const orderedSuppliers = [...suppliers].sort((a, b)=>{
      const sup1 = selectedSuppliers.includes(a[field])
      const sup2 = selectedSuppliers.includes(b[field])
      return sup2 - sup1
    })
    return orderedSuppliers
  }